module.exports = __webpack_public_path__ + "media/images/success-a30c74cd1a676899a38640138474d257.svg";